import React from 'react'

const Uno = () => {
	return (
		<div>
			<div style={{border: 'solid rgba(229, 227, 210)'}}></div>
			<h1>Påmeldingsskjema</h1>
			<h4>Publisert: 04.05.2021, sist oppdatert: 01.07.2021</h4>
			<p>Hei! Veldig koselig at du tenker på å melde deg som fadder! Jeg ser frem til en hyggelig og sosial start på semesteret, og skal gjøre mitt beste for å få til dette.</p>
			<p>
				Fadderuken skjer i uke 33: med studiestart <b>onsdag 18. August. </b>
 				Det vil være noe faglig opplegg som skolen arrangerer, også blir det litt opp til oss å lage diverse sosiale opplegg rundt. 
				Om det skal skje noe hver dag eller ikke, og hvor lange dagene eventuelt blir er opp til oss, og noe jeg tenker vi finner ut av sammen.</p>
			<h2> <a href={"https://forms.gle/Bcasm2EXGt3CEMFe8"}>Er du gira?? Meld deg som fadder her! </a> </h2>
			<p>Jeg har ikke satt noen frist for når det er for sent å melde seg på, men jo tidligere jo bedre for min del. Hvis du er usikker eller lurer på noe er det bare å sende meg en melding via facebook eller mail (siljemfl@ifi.uio.no).</p>
			<p>Alle påmeldte hører fra meg iløpet av sommeren! </p>

			<p> - Klem fra fadderansvarlig Silje Marie Flaaten</p>
			<div style={{border: 'solid rgba(229, 227, 210)'}}></div>

		</div>
	)
}

export default Uno;